import { IMatrixMessage, ILocationMessage, ILocationContent } from '../types';
import { roomData } from '../../room/data';
import { Log } from '@fanfanlo';
import { matrixClient } from '../../client';

const logger = new Log(false, 'im.client.message.handlers.location');

// 内部辅助函数
function addToLocalCache(roomId: string, message: IMatrixMessage) {
  roomData.messagesMap[message.id] = message;
  
  if (!roomData.messages[roomId]) {
    roomData.messages[roomId] = [];
  }
  roomData.messages[roomId].push(message.id);
}

function updateMessageStatus(messageId: string, updates: Partial<IMatrixMessage>) {
  const message = roomData.messagesMap[messageId];
  if (message) {
    roomData.messagesMap[messageId] = {
      ...message,
      ...updates
    };
  }
}

// 导出所有内容
export const locationMessageUtils = {
  // 创建位置消息内容
  createLocationContent: (
    latitude: number,
    longitude: number,
    title: string = '',
    description: string = ''
  ): ILocationContent => ({
    msgtype: 'm.location',
    body: title || `位置: ${latitude}, ${longitude}`,
    geo_uri: `geo:${latitude},${longitude}`,
    info: {
      title,
      description
    }
  }),

  // 发送位置消息
  send: async (
    roomId: string,
    latitude: number,
    longitude: number,
    title: string = '',
    description: string = ''
  ): Promise<string> => {
    const content = locationMessageUtils.createLocationContent(latitude, longitude, title, description);
    const tempId = `temp_${Date.now()}`;
    
    const message: ILocationMessage = {
      id: tempId,
      type: 'm.location',
      sender: matrixClient.client?.getUserId() || '',
      timestamp: Date.now(),
      roomId,
      content,
      status: 'sending'
    };

    addToLocalCache(roomId, message);

    if (!matrixClient.client) {
      logger.error('Matrix client is not initialized');
      throw new Error('Matrix client is not initialized');
    }

    try {
      const eventId = await matrixClient.client.sendMessage(roomId, {
        msgtype: 'm.location',
        body: content.body,
        geo_uri: content.geo_uri,
        info: content.info
      });

      updateMessageStatus(tempId, {
        id: eventId,
        status: 'sent'
      });

      return eventId;
    } catch (error) {
      logger.error('Failed to send location message:', error);
      updateMessageStatus(tempId, {
        status: 'failed',
        error: error instanceof Error ? error.message : 'Unknown error'
      });
      throw error;
    }
  },

  // 处理接收到的位置消息
  handleReceived: (roomId: string, event: any): ILocationMessage => {
    const message: ILocationMessage = {
      id: event.event_id,
      type: 'm.location',
      sender: event.sender,
      timestamp: event.origin_server_ts,
      roomId,
      content: {
        msgtype: 'm.location',
        body: event.content.body,
        geo_uri: event.content.geo_uri,
        info: event.content.info
      },
      status: 'received'
    };

    addToLocalCache(roomId, message);
    return message;
  }
};